export default __webpack_public_path__ + "application.7ad945ccc20ef31885fcd48d3bf1f4d2.svg";